/** Splits a single full name string into first name and rest as surname. */
export function splitFullName(fullName: string): {
  name: string;
  surname: string;
} {
  const trimmed = fullName.trim();
  if (!trimmed) return { name: "", surname: "" };
  const idx = trimmed.indexOf(" ");
  if (idx === -1) return { name: trimmed, surname: "" };
  return {
    name: trimmed.slice(0, idx),
    surname: trimmed.slice(idx + 1).trim(),
  };
}
